"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../../../../util");
exports.ogonek = util_1.simpleSuffix("\u0328");
//# sourceMappingURL=ogonek.js.map